var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9308 14.01C17.7995 14.01 20.9357 10.8737 20.9357 7.00498C20.9357 3.13624 17.7995 0 13.9308 0C10.062 0 6.92578 3.13624 6.92578 7.00498C6.92578 10.8737 10.062 14.01 13.9308 14.01Z",
    fill: "#686868"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3666 20.6687C29.3701 22.6746 27.4864 26.6231 23.8747 26.6231H3.98518C0.373471 26.6231 -1.51024 22.6746 1.49326 20.6687C5.05212 18.2919 9.32921 16.9062 13.9299 16.9062C18.5307 16.9062 22.8078 18.2919 26.3666 20.6687Z",
    fill: "#686868"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileInactive);
export default __webpack_public_path__ + "static/media/profileInactive.be02ccc9bebad9eaff9e5af5c529b664.svg";
export { ForwardRef as ReactComponent };